import React from 'react';
import {
  Dropdown,
  DropdownOverlay,
  ActionList,
  ActionListItem,
  SelectInput,
} from '@razorpay/blade/components';
import { portalStatus } from '../data';
import { RegisterGenericType } from 'forms/useRegister';
import { PortalStatus } from '../types';

export const ESICStatusSelectInput = ({
  register,
  formData,
}: {
  register: RegisterGenericType<{ esicStatus: PortalStatus[] }>;
  formData: Partial<{ esicStatus: PortalStatus[] }>;
}) => {
  return (
    <Dropdown>
      <SelectInput
        label="Status"
        placeholder="Choose Status"
        {...register('esicStatus', 'select')}
        isRequired
        necessityIndicator="required"
      />
      <DropdownOverlay>
        <ActionList>
          <ActionListItem
            title="Registered Employee"
            value={portalStatus.registered}
            isSelected={formData.esicStatus?.[0] === portalStatus.registered}
          />
          <ActionListItem
            title="Not Registered"
            value={portalStatus.notRegistered}
            isSelected={formData.esicStatus?.[0] === portalStatus.notRegistered}
          />
          <ActionListItem
            title="Exit Employee"
            value={portalStatus.exit}
            isSelected={formData.esicStatus?.[0] === portalStatus.exit}
          />
        </ActionList>
      </DropdownOverlay>
    </Dropdown>
  );
};
